import '../../index.css';
import React, { Component } from 'react';
import styles from './Insights.module.css';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import firebase from '../../helpers/firebase';
import Grid from '@material-ui/core/Grid';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import format from 'date-fns/format';
import Button from '@material-ui/core/Button';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import {
  CartesianGrid,
  Line,
  LineChart,
  XAxis,
  YAxis,
  ResponsiveContainer,
} from 'recharts';
import { Helmet } from 'react-helmet';
const yesterdayDate = new Date();
yesterdayDate.setDate(yesterdayDate.getDate() - 1);
const dayBeforeDate = new Date();
dayBeforeDate.setDate(dayBeforeDate.getDate() - 2);

export default class Insights extends Component {
  constructor(props) {
    super(props);
    this.state = {
      meals: [],
      insights: {},
      dateRange: [dayBeforeDate, yesterdayDate],
      mostWasted: [0, ''],
      leastWasted: [Number.MAX_SAFE_INTEGER, ''],
      mostWastedDate: [0, ''],
      leastWastedDate: [Number.MAX_SAFE_INTEGER, ''],
      mostWastedGraph: [],
      leastWastedGraph: [],
      maxIncrease: [Number.MAX_SAFE_INTEGER, ''],
      maxDecrease: [0, ''],
      maxIncreaseGraph: [],
      maxDecreaseGraph: [],
    };
  }

  componentDidMount() {
    if (this.props.diningHall && this.props.campus) {
      this.getMealData();
    }
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.diningHall !== prevProps.diningHall ||
      this.props.campus !== prevProps.campus ||
      this.state.dateRange !== prevState.dateRange
    ) {
      this.getMealData();
    }
  }

  onDateRangeChange = (date) => {
    this.setState({ dateRange: date });
  };

  dateLastWeek = () => {
    var today = new Date();
    var lastWeek = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 7
    );
    this.setState({ dateRange: [lastWeek, today] });
  };

  dateLastMonth = () => {
    var today = new Date();
    var lastMonth = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 30
    );
    this.setState({ dateRange: [lastMonth, today] });
  };

  dateLastYear = () => {
    var today = new Date();
    var lastYear = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 365
    );
    this.setState({ dateRange: [lastYear, today] });
  };

  createReport = () => {
    html2canvas(document.querySelector('#Home')).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      var hall = this.props.diningHall;
      var letter = hall.charAt(0);
      letter = letter.toUpperCase();
      hall = hall.replace(hall.charAt(0), letter);
      if (hall === 'Aberdeen') {
        hall += '-Inverness';
      }
      var firstDate = format(this.state.dateRange[0], 'yyyy-MM-dd');
      var secondDate = format(this.state.dateRange[1], 'yyyy-MM-dd');
      var filename = 'Insights ';
      filename += hall + ' ' + firstDate + ' - ' + secondDate + '.pdf';
      pdf.addImage(imgData, 'PNG', 10, 10, 180, 150);
      pdf.setFontType('bold');
      pdf.setFontSize(20);
      pdf.text(105, 18.5, hall, 'center');
      pdf.save(filename);
    });
  };

  async getMealData() {
    const isoDateRange = [
      format(this.state.dateRange[0], 'yyyy-MM-dd'),
      format(this.state.dateRange[1], 'yyyy-MM-dd'),
    ];
    const data = await firebase
      .firestore()
      .collection(
        `campus/${this.props.campus}/halls/${this.props.diningHall}/data`
      )
      .where(firebase.firestore.FieldPath.documentId(), '>=', isoDateRange[0])
      .where(firebase.firestore.FieldPath.documentId(), '<=', isoDateRange[1])
      .get();
    const general_info = await firebase
      .firestore()
      .doc(`campus/${this.props.campus}/halls/${this.props.diningHall}`)
      .get();

    let meals = general_info.data()['dishes'];
    meals = meals.filter(function (value) {
      if (value === 'no_plate' || value === 'empty_plate') {
        return false;
      }
      return true;
    });

    let history = {};

    data.docs.forEach((doc) => {
      Object.entries(doc.data()).forEach(([meal, items]) => {
        Object.entries(items).forEach(([item, score]) => {
          if (score > 0.5 && item !== 'no_plate' && item !== 'empty_plate') {
            if (!(doc.id in history)) {
              history[doc.id] = {};
            }
            if (!(item in history[doc.id])) {
              history[doc.id][item] = 0.0;
            }
            history[doc.id][item] += score;
          }
        });
      });
    });

    let insights = {};
    let mostWasted = [0, ''];
    let leastWasted = [Number.MAX_SAFE_INTEGER, ''];
    let mostWastedDate = [0, ''];
    let leastWastedDate = [Number.MAX_SAFE_INTEGER, ''];
    let sumWastage = {};
    let mostWastedGraph = [];
    let leastWastedGraph = [];

    let maxIncreaseGraph = [];
    let maxDecreaseGraph = [];
    let maxIncrease = [Number.MAX_SAFE_INTEGER, ''];
    let maxDecrease = [0, ''];
    let firstDate = Object.keys(history)[0];
    let lastDate = Object.keys(history)[Object.keys(history).length - 1];

    for (let i = 1; i < Object.keys(history).length; i++) {
      let date = Object.keys(history)[i];
      for (let j = 0; j < Object.keys(history[date]).length; j++) {
        let meal = Object.keys(history[date])[j];
        if (!(meal in sumWastage)) {
          sumWastage[meal] = 0;
        }
        sumWastage[meal] += history[date][meal];
      }
    }

    Object.keys(sumWastage).forEach((i) => {
      if (sumWastage[i] > mostWasted[0]) {
        mostWasted[0] = sumWastage[i];
        mostWasted[1] = i;
      }
      if (sumWastage[i] < leastWasted[0]) {
        leastWasted[0] = sumWastage[i];
        leastWasted[1] = i;
      }
    });

    for (let i = 1; i < Object.keys(history).length; i++) {
      let date = Object.keys(history)[i];

      if (history[date][mostWasted[1]] > mostWastedDate[0]) {
        mostWastedDate[0] = history[date][mostWasted[1]];
        mostWastedDate[1] = date;
      }
      if (history[date][leastWasted[1]] < leastWastedDate[0]) {
        leastWastedDate[0] = history[date][leastWasted[1]];
        leastWastedDate[1] = date;
      }
    }

    meals.forEach((i) => {
      if (history[firstDate] && history[lastDate]) {
        let diff = history[firstDate][i] - history[lastDate][i];
        if (diff < maxIncrease[0]) {
          maxIncrease[0] = diff;
          maxIncrease[1] = i;
        }
        if (diff > maxDecrease[0]) {
          maxDecrease[0] = diff;
          maxDecrease[1] = i;
        }
      }
    });

    for (let i = 1; i < Object.keys(history).length; i++) {
      let date = Object.keys(history)[i];
      mostWastedGraph.push({
        meal: mostWasted[1],
        value: history[date][mostWasted[1]],
        date: date,
      });
      leastWastedGraph.push({
        meal: leastWasted[1],
        value: history[date][leastWasted[1]],
        date: date,
      });
      maxIncreaseGraph.push({
        meal: maxIncrease[1],
        value: history[date][maxIncrease[1]],
        date: date,
      });
      maxDecreaseGraph.push({
        meal: maxDecrease[1],
        value: history[date][maxDecrease[1]],
        date: date,
      });
    }

    for (let i = 1; i < Object.keys(history).length; i++) {
      let date = Object.keys(history)[i];
      let last_date = Object.keys(history)[i - 1];

      for (let j = 0; j < Object.keys(history[date]).length; j++) {
        let meal = Object.keys(history[date])[j];
        if (!(meal in insights)) {
          insights[meal] = [];
        }

        if (history[date][meal] / history[last_date][meal] > 1.3) {
          if (!('more_waste' in insights[meal])) {
            insights[meal]['more_waste'] = [];
          }
          insights[meal]['more_waste'].push(date);
        }

        if (history[date][meal] / history[last_date][meal] < 0.7) {
          if (!('less_waste' in insights[meal])) {
            insights[meal]['less_waste'] = [];
          }
          insights[meal]['less_waste'].push(date);
        }
      }
    }
    this.setState({
      meals: meals,
      insights: insights,
      leastWasted: leastWasted,
      mostWasted: mostWasted,
      mostWastedDate: mostWastedDate,
      leastWastedDate: leastWastedDate,
      mostWastedGraph: mostWastedGraph,
      leastWastedGraph: leastWastedGraph,
      maxIncrease: maxIncrease,
      maxDecrease: maxDecrease,
      maxIncreaseGraph: maxIncreaseGraph,
      maxDecreaseGraph: maxDecreaseGraph,
    });
  }

  render() {
    return (
      <div id={'Home'}>
        <Helmet>
          <meta
            name="description"
            content="DeWaste is the easiest way to quickly and reliably reduce food waste. Using image analysis, we can give you accurate wastage data instantly."
          />

          <meta
            itemProp="name"
            content="DeWaste | Food Waste Analysis for all dining institutions"
          />
          <meta
            itemProp="description"
            content="DeWaste is the easiest way to quickly and reliably reduce food waste. Using image analysis, we can give you accurate wastage data instantly."
          />
          <meta itemProp="image" content="https://de-waste.com/logo.png" />

          <meta property="og:image" content="https://de-waste.com/logo.png" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="DeWaste" />
          <meta
            property="og:description"
            content="DeWaste is the easiest way to quickly and reliably reduce food waste. Using image analysis, we can give you accurate wastage data instantly."
          />
          <meta property="og:site_name" content="DeWaste" />
          <meta property="og:url" content="https://de-waste.com" />

          <meta name="twitter:card" content="summary" />
          <meta name="twitter:image" content="https://de-waste.com/logo.png" />
          <meta name="twitter:title" content="DeWaste" />
          <meta
            name="twitter:description"
            content="DeWaste is the easiest way to quickly and reliably reduce food waste. Using image analysis, we can give you accurate wastage data instantly."
          />
        </Helmet>

        <div className={styles.datePickerContainer}>
          <DateRangePicker
            onChange={this.onDateRangeChange}
            value={this.state.dateRange}
          />
        </div>

        <div
          className={styles.dateRangeButtonsContainer}
          data-html2canvas-ignore="true"
        >
          <Button
            className={styles.dateRangeButton}
            variant="contained"
            onClick={this.dateLastWeek}
          >
            Last Week
          </Button>
          <Button
            className={styles.dateRangeButton}
            variant="contained"
            onClick={this.dateLastMonth}
          >
            Last Month
          </Button>
          <Button
            className={styles.dateRangeButton}
            variant="contained"
            onClick={this.dateLastYear}
          >
            Last Year
          </Button>
          <Button
            className={styles.dateRangeButton}
            variant="contained"
            onClick={this.createReport}
          >
            Download Report
          </Button>
        </div>

        <div className="index" style={{ display: 'flex' }}>
          <Grid
            container
            spacing={3}
            style={{ marginLeft: '10px', marginRight: '10px' }}
          >
            <Grid item xs={6}>
              <Card className={styles.card}>
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">
                    Most Wasted
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                  >
                    {this.state.mostWasted[1]} were the most wasted with the
                    wastage peaking on {this.state.mostWastedDate[1]}
                  </Typography>
                  <div style={{ width: '100%', height: '300px' }}>
                    <ResponsiveContainer>
                      <LineChart
                        margin={{ top: 20, right: 30, left: 0, bottom: 0 }}
                        data={this.state.mostWastedGraph}
                      >
                        <XAxis dataKey="date" />
                        <YAxis dataKey="value" />
                        <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                        <Line
                          type="monotone"
                          dataKey="value"
                          stroke="#8884d8"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={6}>
              <Card className={styles.card}>
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">
                    Least Wasted
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                  >
                    {this.state.leastWasted[1]} were least wasted with the
                    wastage dipping on {this.state.leastWastedDate[1]}. Good
                    job!
                  </Typography>
                  <div style={{ width: '100%', height: '300px' }}>
                    <ResponsiveContainer>
                      <LineChart
                        width={500}
                        height={300}
                        data={this.state.leastWastedGraph}
                      >
                        <XAxis dataKey="date" />
                        <YAxis dataKey="value" />
                        <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                        <Line
                          type="monotone"
                          dataKey="value"
                          stroke="#8884d8"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={6}>
              <Card className={styles.card}>
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">
                    Biggest Increase
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                  >
                    {this.state.maxIncrease[1]} had the largest increase in
                    wastage
                  </Typography>
                  <div style={{ width: '100%', height: '300px' }}>
                    <ResponsiveContainer>
                      <LineChart
                        width={500}
                        height={300}
                        data={this.state.maxIncreaseGraph}
                      >
                        <XAxis dataKey="date" />
                        <YAxis dataKey="value" />
                        <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                        <Line
                          type="monotone"
                          dataKey="value"
                          stroke="#8884d8"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={6}>
              <Card className={styles.card}>
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">
                    Biggest Decrease
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                  >
                    {this.state.maxDecrease[1]} had the largest decrease in
                    wastage. Good job!
                  </Typography>
                  <div style={{ width: '100%', height: '300px' }}>
                    <ResponsiveContainer>
                      <LineChart
                        width={500}
                        height={300}
                        data={this.state.maxDecreaseGraph}
                      >
                        <XAxis dataKey="date" />
                        <YAxis dataKey="value" />
                        <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                        <Line
                          type="monotone"
                          dataKey="value"
                          stroke="#8884d8"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}
